<template>
  <div id="Article">
    <div id="TopBTCotainer">
      <img id="TopBT1" @click="returnPage()"
           src="../../assets/1st/article_top_bt1.png">
    </div>
    <div id="articleScroller" :style="articleScrollerStyle">
      <div id="articleCantainer">
        <div id="articleCoverCotainer">
          <img :src="require('../../assets/1st/Articles/Article_'+thisArticle+'/banner.jpg')">
        </div>
        <div id="articleCotainer" v-if="AllList.length>0">
          <div id="articleTitle">
            {{AllList[thisArticle].title}}
          </div>
          <div id="articleSecondTitle">
<!--            {{AllList[thisArticle].SecondTitle}}-->
          </div>
          <div id="articleDate">
            {{AllList[thisArticle].date}}
          </div>
          <div id="articleContent">
            <component :is="ArticleContent"></component>
          </div>
          <div id="MoreCotainer">
            <div id="MoreLogoCotainer">
              <img src="../../assets/1st/article_more_logo.png">
            </div>
            <div id="MoreTitleContianer">
              <div class="MoreTitle" @click="viewArticle(r)" v-for="r in rad">{{AllList[r].title}}</div>
            </div>
          </div>
          <div id="BottomLogoCotainer">
            <img src="../../assets/1st/articl_bottom_logo.png">
          </div>
        </div>
      </div>
    </div>
    <div style="position:fixed;right:0px;bottom:28rem;width: 13.4rem;"
         @click="returnMain()">
      <img src="../../assets/1st/article_main_bt.png" style="width: 100%">
    </div>
    <div style="position:fixed;right:0px;bottom:15rem;width: 13.4rem;"
         @click="sharePageShow=true">
      <img src="../../assets/1st/article_share_bt.png" style="width: 100%">
    </div>
    <div style="position:fixed;left:0px;top:0px;"
         v-if="sharePageShow" @click="sharePageShow=false">
      <img src="../../assets/1st/share.png" style="width: 100%">
    </div>
  </div>
</template>

<script>
    import store from '../../store/1st'
    import Article0 from "./Articles/Article0";
    import Article1 from "./Articles/Article1";
    import Article2 from "./Articles/Article2";
    import Article3 from "./Articles/Article3";
    import Article4 from "./Articles/Article4";
    import Article5 from "./Articles/Article5";
    import Article6 from "./Articles/Article6";
    import Article7 from "./Articles/Article7";
    import Article8 from "./Articles/Article8";
    import Article9 from "./Articles/Article9";
    import Article10 from "./Articles/Article10";
    import Article11 from "./Articles/Article11";
    import Article12 from "./Articles/Article12";
    import Article13 from "./Articles/Article13";

    let AticleComponents=[
      Article0,Article1,Article2,Article3,Article4,
      Article5,Article6,Article7,Article8,Article9,
      Article10,Article11,Article12,Article13
    ];
    export default {
      name: "Article",
      store,
      data(){
        return {
          AllList:[],
          sharePageShow:false,
          rad:[]
        }
      },
      mounted() {
        this.AllList=this.$store.state.ArticleList
        var scrollerConfig = {
          '//Description' : 'Default scroller with no configuration'
        };
        this.scroller = new Scroller('#articleScroller', scrollerConfig);
        this.setMore(this.thisArticle);
      },
      methods:{
        returnPage(){
          this.$store.commit('PopArticle');
          if(this.$store.state.ArticleStack.length>0){
            let id=this.$store.state.ArticleStack[this.$store.state.ArticleStack.length-1];
            this.scroller._scrollTo(0,0)
            this.setMore(id);
            this.$router.replace("/Article/"+id)
          }else{
            this.$router.replace("/ArticleList")
          }
        },
        setMore(thisid){
          this.rad=[];
          let r;
          while (this.rad.length<4){
            r=Math.random()
            r*=100;
            r=parseInt(r)
            r=r%this.AllList.length
            if((this.rad.indexOf(r)<0)&&(r!=thisid)) {
              this.rad.push(r);
            }
          }
          this.count(0,thisid+1);

          let ShareInfo={
            title:this.AllList[this.thisArticle].shareTitle,
            desc: this.AllList[this.thisArticle].shareDes,
            link: "https://www.primomedia.cn/m/oceanengine/oe_yujian/1st.html#/Article/"+thisid,
            icon: "Articles/Article_"+thisid+"/icon.jpg",
            count:thisid+1
          };
          this.$store.commit('setShareInfo',ShareInfo);
          this.setZhuanFa();
        },
        returnMain(){
          this.$store.commit('ClearArticle');
          this.$store.commit("SetClass",0)
          this.$router.replace("/ArticleList")
        },
        viewArticle(id){
          this.scroller._scrollTo(0,0)
          this.setMore(id);
          this.$store.commit('PushArticle',id);
          this.$router.replace("/Article/"+id)
        },
        count:function (isshare,id){
          let params = new URLSearchParams();
          params.append('id', id);
          params.append('issue', 1);
          params.append('isshare', isshare);
          let isview=this.$cookies.get('isview_'+id);
          if(isview) {
            params.append('isview', 1);
          }else{
            params.append('isview', 0);
            this.$cookies.set('isview_'+id,1,'1d')
          }

          this.axios.post('count.php',params)
            .then((response)=>{
            })
            .catch((error)=>{
              console.log(error);
            });
        },
        setZhuanFa:function (){
          let shareData = {
            title:this.$store.state.ShareInfo.title,
            desc: this.$store.state.ShareInfo.desc,
            link: this.$store.state.ShareInfo.link,
            imgUrl: require('../../assets/1st/'+this.$store.state.ShareInfo.icon),
            success:function(){
              this.count(1,this.$store.state.ShareInfo.count);
            }.bind(this)
          };
          wx.onMenuShareAppMessage(shareData);
          wx.onMenuShareTimeline(shareData);
        }
      },
      computed:{
        thisArticle(){
          return parseInt(this.$route.params.id);
        },
        ArticleContent:function () {
          return AticleComponents[this.thisArticle];
        },
        articleScrollerStyle:function () {
          return {
            height:(this.$store.state.WindowSize.WindowHeightRem-11.1)+'rem',
          }
        },
      }
    }
</script>

<style scoped>
  #Article{
    width: 112.5rem;
    background: #ffffff;
    box-shadow: 0rem 0rem 2rem 0.1rem #ccc;
  }
  #TopBTCotainer{
    width: 100%;
    height: 11.1rem;
    background: #ffffff;
  }
  #TopBT1{
    width: 12.6rem;
    margin-top: 3.5rem;
    margin-left: 9rem;
  }
  #articleScroller{width: 100%}
  #articleCoverCotainer,#articleCoverCotainer img{
    width: 100%;
  }
  #articleCotainer{
    width: 112.5rem;
    padding: 4.5rem;
    margin-top: -4.5rem;
    border-radius: 4.5rem;
    background: #ffffff;
  }
  #articleTitle{
    color: black;
    font-weight: bolder;
    width: 100%;
    padding: 4.5rem;
    line-height:6.4rem;
    font-size:5.6rem;
  }
  #articleSecondTitle{
    color: black;
    border-top: solid #f1f1f1;
    width: 100%;
    padding-left: 4.5rem;
    padding-right: 4.5rem;
    padding-top: 1rem;
    line-height: 5.2rem;
    font-size: 4rem;
    margin-top: 6.6rem;
    border-width: 0.1rem;
  }
  #articleDate{
    color: #b3b3b3;
    border-bottom: solid #f1f1f1;
    width: 100%;
    padding-left: 4.5rem;
    padding-right: 4.5rem;
    padding-bottom: 2rem;
    line-height: 2.5rem;
    font-size: 4rem;
    margin-top: 1.5rem;
    border-width: 0.1rem;
  }
  #articleContent{
    width: 100%;
    padding-bottom: 16rem;
    margin-top: 4.5rem;
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }
  #MoreCotainer{
    width: 100%;
    border-bottom: solid #f1f1f1;
    border-top: solid #f1f1f1;
    border-width: 0.1rem;
  }
  #MoreLogoCotainer{
    width: 45.3rem;
    margin-left: 29.1rem;
    margin-top: -5.55rem;
  }
  #MoreLogoCotainer img{
    width: 100%;
  }
  #MoreTitleContianer{
    width: 100%;
    padding: 4.5rem;
  }
  .MoreTitle{
    width: 100%;
    text-align: center;
    font-size: 3.5rem;
    line-height: 5rem;
    margin-top: 2rem;
    margin-bottom: 2rem;
    color: #004edc;
  }
  #BottomLogoCotainer{
    width: 53.9rem;
    margin: 24.8rem;
  }
  #BottomLogoCotainer img{
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/1st/Article.vue